import React, { Component } from "react";
import { Box, Breadcrumbs, Grid, Tab, Tabs, Typography } from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import CtTxt from "./CustomTool/CtTxt";
import "./AMCSiteInfo.css";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";

import { withRouter } from "../HOC/withRouter";

/* ===================== CLASS COMPONENT ===================== */
class AMCSiteInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabValue: 0,
      formData: {
        branchName: "",
        serviceLocation: "",
        siteName: "",
        siteAddress: "",
        googlePinLocation: "",
        siteApproachability: "",
        priorityService: "",
        remarks: "",
      },
    };
  }

  /* ---------- TAB CHANGE ---------- */
  handleTabChange = (_, newValue) => {
    this.setState({ tabValue: newValue });

    if (newValue === 1) {
      // Goes to /AMCLiftInfo
      this.props.navigateTo("AMCLiftInfo");
    }
  };

  render() {
    const { tabValue, formData } = this.state;

    const branchOptions = [{ value: "" }];
    const serviceLocationOptions = [{ value: "" }, { value: "" }];
    const approachabilityOptions = [
      { value: "" },
      { value: "" },
      { value: "" },
    ];
    const priorityOptions = [{ value: "" }, { value: "" }, { value: "" }];

    return (
      <Grid className="amc-siteinfo-page">
        <Typography fontSize={30} fontWeight={600} marginBottom={2}>
          AMC Details
        </Typography>

        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/#/Dashboard">
            Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="/#/AMCDashboard">
            AMC Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="/#/AMCList">
            AMC List
          </Link>
          <Link underline="hover" color="inherit" href="/#/AMCRegistration">
            AMC Registration
          </Link>
          <Typography sx={{ color: "text.primary" }}>Lift 1</Typography>
        </Breadcrumbs>
        {/* ---------- TABS ---------- */}
        <Grid className="amc-siteinfo-tabs">
          <Tabs value={tabValue} onChange={this.handleTabChange}>
            <Tab label="Site Info" />
            <Tab label="Lift Info" />
          </Tabs>
        </Grid>

        {/* ---------- PANEL ---------- */}
        <Grid className="amc-siteinfo-panel">
          <Grid className="amc-siteinfo-header">
            <Grid className="amc-siteinfo-header-left">
              <Typography fontSize={25} fontWeight={550}>
                Site Info
              </Typography>

              <CtBtn
                label="SAVE"
                iconName="save"
                firstletterBig={false}
                className="secondary-button"
              />

              <CtBtn
                label="DELETE"
                iconName="delete"
                firstletterBig={false}
                className="delete-button"
              />
            </Grid>

            <Grid className="amc-siteinfo-status">AMC Active</Grid>
          </Grid>

          <Typography fontSize={16} fontWeight={600}>
            Basic Information
          </Typography>

          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item>
              <CtCmbEditable
                id="branchName"
                label="Branch Name"
                items={branchOptions}
                value={formData.branchName}
                colID="value"
                width={240}
                disabled
              />
            </Grid>

            <Grid item>
              <CtCmbEditable
                id="serviceLocation"
                label="Service Location"
                items={serviceLocationOptions}
                value={formData.serviceLocation}
                colID="value"
                width={240}
                disabled
              />
            </Grid>

            <Grid item>
              <CtTxt
                id="siteName"
                label="Site Name"
                value={formData.siteName}
                width={240}
                disabled
              />
            </Grid>
          </Grid>

          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item>
              <CtTxt
                id="siteAddress"
                label="Site Address"
                value={formData.siteAddress}
                width={500}
                disabled
              />
            </Grid>

            <Grid item>
              <CtTxt
                id="googlePinLocation"
                label="Google Pin Point Location"
                value={formData.googlePinLocation}
                width={240}
                disabled
              />
            </Grid>
          </Grid>

          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item>
              <CtCmbEditable
                id="siteApproachability"
                label="Site Approachability"
                items={approachabilityOptions}
                value={formData.siteApproachability}
                colID="value"
                width={240}
                disabled
              />
            </Grid>

            <Grid item>
              <CtCmbEditable
                id="priorityService"
                label="Proity Of Service & Call Back"
                items={priorityOptions}
                value={formData.priorityService}
                colID="value"
                width={240}
                disabled
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <CtMultiLineText
              id="remarks"
              label="Remarks"
              value={formData.remarks}
              width="100%"
              rows={2}
              disabled
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

/* ===================== EXPORT ===================== */
export default withRouter(AMCSiteInfo);
